import React from 'react';
import { entries } from 'd3';
import { BarLoader } from 'react-spinners';
import { Typography, Grid, Divider } from '@material-ui/core';
import { PieGraph, BarGraph, LineGraph } from './graphs';
import CanadaMap from './CanadaMap';
import DataManager from '../lib/DataManager';

export default class Visualization extends React.Component {
  constructor(props) {
    super(props);

    const data = entries({
      a: [{year: 2010, value: 5}, {year: 2018, value: 10}],
      b: [{year: 2000, value: 2}, {year: 2010, value: 9}]
    });

    this.state = {
      loading: true,
      data,
      activeProvs: []
    }
    
    this.shouldUpdate = true; // Find a better way to handle this
  }

  componentDidMount() {
    this.data = new DataManager();
    
    // setTimeout(() => {
    //   this.setState(() => {
    //     return {
    //       loading: false
    //     }
    //   });  
    // }, 5000);

    this.setState(() => {
      return {
        loading: false
      }
    });   
  }

  componentDidUpdate(prevProps, prevState) {
    const [prevMin, prevMax] = prevProps.yearRange,
          [min, max] = this.props.yearRange;

    const yearUpdated = prevMin !== min || prevMax !== max,
          typeUpdated = prevProps.typeFilter !== this.props.typeFilter,
          unitUpdated = prevProps.unitFilter !== this.props.unitFilter,
          provUpdated = prevState.activeProvs.length !== 
            this.state.activeProvs.length;
    
    if (yearUpdated) return;

    if (typeUpdated || unitUpdated || provUpdated) {
      this.data.processData(this.state.activeProvs, [2000, 2018], 
        this.props.unitFilter, this.props.typeFilter);
      
      this.setState(() => {
        return {
          data: this.data.line
        }
      });
    }
  }

  shouldComponentUpdate() {
    if (this.shouldUpdate) {
      return true;
    } else {
      this.shouldUpdate = true;
      return false;
    }
  }

  handleProvinceClick = (provs) => {
    if (this.state.activeProvs.length === provs.size) return;
    
    const activeProvs = [...provs];
    this.props.onProvSelect(activeProvs, this.data.uncrpd);
    this.setState(() => {return {activeProvs};});
  }

  handleGraphClick = (selectedProgram) => {
    if (this.state.activeProvs.length === 1) {
      const programName = selectedProgram.data 
        ? selectedProgram.data.key 
        : selectedProgram.key;
      
      const programData = this.data.getProgramData(programName, 
        this.state.activeProvs[0]);

      if (programData) {
        this.shouldUpdate = false;
        this.props.onProgramSelect(programData);
      }
    }
  }

  generateVisualizationTitle() {
    const { typeFilter } = this.props;
    let type = 'Selected Type';
    if (typeFilter === 'program') type = 'Program';
    else if (typeFilter === 'gvtMinistry') type = 'Government Ministry';
    else if (typeFilter === 'pType') type = 'Program Type';

    const [minYear, maxYear] = this.props.yearRange;
    let years = 'from Selected Year Range';
    if (minYear === maxYear) years = `in ${minYear}`;
    else years = `from ${minYear} to ${maxYear}`;
    
    const units = this.props.unitFilter === 'expenditures' 
      ? 'Expenditures' 
      : 'Caseloads';
    
    const { activeProvs } = this.state;
    const provinces = activeProvs.length > 0 && activeProvs.length < 3 
      ? activeProvs.join(' and ') 
      : 'Selected Provinces';

    return `${units} ${activeProvs.length > 1 ? '' : `by ${type}`} in 
      ${provinces} ${years}`;
  }

  render() {
    const PaddedDivider = (
      <div>
        <br />
        <Divider variant="middle" />
        <br />
      </div>
    );

    const title = (
      <div>
        <Typography variant='h3' align='center'>
          Data Visualization
        </Typography>
        { PaddedDivider }
      </div>
    );

    if (this.state.loading) {
      return (
        <div align="center">
          {title}
          <br />
          <BarLoader height="5" width="300" color="#1e59a5"/>
          <Typography variant="caption">
            loading data
          </Typography>
          { PaddedDivider }
        </div>
      );
    };

    let unit = this.props.unitFilter === 'expenditures' 
      ? 'Millions of Dollars' 
      : 'Caseloads';

    if (this.state.activeProvs.length > 1 && unit === 'Millions of Dollars') {
      unit = 'Expenditures Per Capita ($/Person)';
    }

    return (
      <div>
        {title}
        <CanadaMap
          onProvSelect={this.handleProvinceClick}
        />
        { PaddedDivider }
        <Typography variant='h4' align='center'>
          {this.generateVisualizationTitle()}
        </Typography>
        { PaddedDivider }
        <Grid container={true} spacing={3} alignItems={'center'}>
          <Grid item xs={12} sm={5}>
            <PieGraph
              data={this.state.data}
              onGraphClick={this.handleGraphClick}
              yearRange={this.props.yearRange}
              transitionTime={this.props.doTransitions ? 1000 : 0}
            />
          </Grid>
          <Grid item xs={12} sm={7}>
            <BarGraph
              data={this.state.data}
              onGraphClick={this.handleGraphClick}
              yearRange={this.props.yearRange}
              transitionTime={this.props.doTransitions ? 1000 : 0}
              units={unit}
            />
          </Grid>
          {
            this.props.yearRange[0] !== this.props.yearRange[1] && (
              <Grid item xs={12}>
                <LineGraph
                  data={this.state.data}
                  units={unit}
                  yearRange={this.props.yearRange}
                  transitionTime={this.props.doTransitions ? 1000 : 0}
                />
              </Grid>
            )
          }
        </Grid>
        {/* { PaddedDivider } */}
      </div>
    );
  }
}